import './home.css'
import './learn.css'
import './learn-docker.css'
import * as THREE from 'three'
import atmosphereVertexShader from './shaders/atmosphereVertex.glsl';
import atmosphereFragmentShader from './shaders/atmoshereFragment.glsl'
import TypeIt from "typeit";

//Loading 
const textureLoader = new THREE.TextureLoader()

const normalTexture = textureLoader.load('./texture/texture2.jpg');
const starTexture= textureLoader.load('./texture/stars.png');


// Debug

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

// Objects
const geometry = new THREE.SphereGeometry(.8,65,50);

// Materials
const material = new THREE.MeshStandardMaterial()


material.normalMap = normalTexture;
//material.color = new THREE.Color(0xFF0000)

// Mesh
const sphere = new THREE.Mesh(geometry,material)



const particlesGeometry = new THREE.BufferGeometry();
const particlesCnt = 500;

const posArray = new Float32Array(particlesCnt * 3);

for(let i = 0 ; i < particlesCnt *3 ;i++)
{
     posArray[i] =( Math.random()-0.5)*5 ;
     //posArray[i].z =.3 ;
}

particlesGeometry.setAttribute('position', new THREE.BufferAttribute(posArray,3))
const pointMaterial = new THREE.PointsMaterial({
  size:0.005,
  map:starTexture,
  transparent:true,
  color:"white",
  side:THREE.BackSide
})
const particlesMesh = new THREE.Points(particlesGeometry,pointMaterial);

scene.add(particlesMesh,sphere)


// Objects
const atmosphereSphere = new THREE.SphereGeometry(.8,65,50);

// Materials
const atmosphereMaterial = new THREE.ShaderMaterial({
    vertexShader:atmosphereVertexShader,
    fragmentShader:atmosphereFragmentShader,
    blending:THREE.AdditiveBlending,
    side:THREE.BackSide
})


// Mesh
const atmosphere = new THREE.Mesh(atmosphereSphere,atmosphereMaterial)
atmosphere.scale.set(1.1,1.1,1.1)
scene.add(atmosphere)

// Lights

const pointLight = new THREE.PointLight(0xffffff, 0.1)
pointLight.position.x = 2
pointLight.position.y = 3
pointLight.position.z = 4
scene.add(pointLight)

const pointLight2 = new THREE.PointLight(0xff0000, 0.2)
pointLight2.position.set(2.3 ,1.58 ,-0.3)

pointLight2.intensity=0.41
scene.add(pointLight2)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}



if (canvas != null)
{
    window.addEventListener('resize', () =>
    {
        // Update sizes
        sizes.width = window.innerWidth
        sizes.height = window.innerHeight

        // Update camera
        camera.aspect = sizes.width / sizes.height
        camera.updateProjectionMatrix()

        // Update renderer
        renderer.setSize(sizes.width, sizes.height)
        renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    })

    /**
     * Camera
     */
    // Base camera

    const camera = new THREE.PerspectiveCamera(80, sizes.width / sizes.height, 0.1, 100)
    camera.position.x = 0
    camera.position.y = 0
    camera.position.z = 2
    scene.add(camera)
    const renderer = new THREE.WebGLRenderer({
        canvas: canvas,
        alpha:true
    })
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    
    /**
     * Animate
     */
    let mouseX = 0
    let mouseY = 0 
    
    let targetX = 0 
    
    
    const windowHalfX = window.innerWidth / 2;
    const windowHalfY = window.innerHeight/2;
    document.addEventListener('mousemove',(e)=>{
    
        mouseX=(e.clientX - windowHalfX);
        mouseY = (e.clientY - windowHalfY);
    
    })
    const clock = new THREE.Clock()
    
    const tick = () =>
    {
        targetX = mouseX * .001;
        
        const elapsedTime = clock.getElapsedTime()
    
        particlesMesh.rotation.y +=0.003
    
        // Update objects
        sphere.rotation.y = .2 * elapsedTime
        sphere.rotation.y+=.05*(targetX - sphere.rotation.y)
       
        // Update Orbital Controls
        // controls.update()
    
        // Render
        renderer.render(scene, camera)
    
        // Call tick again on the next frame
        window.requestAnimationFrame(tick)
    }
    
    tick()
    //Typing animation :
new TypeIt("#presentation", {
    speed: 50,
    startDelay: 900,
    loop: true
  })
    .type("Full Stack Web Developer ", {delay: 255})
    .pause(1000)
    .delete()
    .type('Mobile Developer', {delay: 225})
    .pause(1000)
    .delete()
    .type('DevOps', {delay: 225})
    
    .go();

let options = {
        "cursorOuter": "circle-basic",
        "hoverEffect": "circle-move",
        "hoverItemMove": false,
        "defaultCursor": false,
        "outerWidth": 30,
        "outerHeight": 30
          };
 magicMouse(options);

const  projects = document.querySelectorAll('.project');
const   observer = new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
        entry.target.classList.toggle("show-project",entry.isIntersecting)
        if(entry.isIntersecting) observer.unobserve(entry.target);
    })
 
 },{
     threshold:0.5
 })
projects.forEach(project=>{
    observer.observe(project)
})


 const rocketproject = document.querySelectorAll('.contact');
 const rocketobserver = new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
        console.log(entry.target.firstChild )
        entry.target.firstChild .classList.toggle("show-rocket",entry.isIntersecting)
        if(entry.isIntersecting) {
           
            document.querySelectorAll('.quotes')[0].classList.toggle("show-quotes",entry.isIntersecting)
        }
        console.log(getComputedStyle(entry.target).marginBottom)
        if(!entry.isIntersecting)
        {
            document.querySelectorAll('.quotes')[0].classList.remove("show-quotes")
        }
       
      
    })
  
 
 },{
     threshold:0.5
 })
 rocketproject.forEach(rocket=>{
    rocketobserver.observe(rocket)
})




}





